import { render, staticRenderFns } from "./GameFavorites.vue?vue&type=template&id=b657e35e&scoped=true&"
import script from "./GameFavorites.vue?vue&type=script&lang=js&"
export * from "./GameFavorites.vue?vue&type=script&lang=js&"
import style0 from "./GameFavorites.vue?vue&type=style&index=0&id=b657e35e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b657e35e",
  null
  
)

export default component.exports